import {useEffect, useEffectEvent, useState} from 'react';
import type {DataLoadStatus, NationalAgent} from 'api';
import {getAgentByNationalId} from 'api';
import {useGetTokens} from 'services/auth';

export const useAgentNoraf = (agent: Pick<NationalAgent, 'nationalId'>) => {
  const getTokens = useGetTokens();
  const [data, setData] = useState<DataLoadStatus<NationalAgent>>({
    status: 'NotLoaded',
  });
  const onSetData = useEffectEvent(setData);

  useEffect(() => {
    if (agent.nationalId) {
      onSetData({status: 'Loading'});
      getAgentByNationalId(agent.nationalId, getTokens)
        .then(norafData => {
          onSetData({
            status: 'Loaded',
            data: norafData,
          });
        })
        .catch(error => {
          onSetData({
            status: 'Failed',
            error: error,
          });
        });
    }
  }, [agent.nationalId, getTokens]);

  return data;
};
